<template>
  <div v-bind="$attrs" class="input">
    <fade-in-transition>
      <error-popup v-if="error" :error="error" class="input__popup" />
    </fade-in-transition>
    <input-text
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :has-error="hasError"
      :is-disabled="isDisabled"
      :is-readonly="isReadonly"
      :style="inputStyle"
      class="input__text"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import FadeInTransition from '@/mikan/_shared/components/transitions/FadeInTransition.vue';
import ErrorPopup from '@/mikan/_shared/components/atoms/ErrorPopup.vue';
import InputText from '@/mikan/_shared/components/atoms/InputText.vue';

export default {
  components: {
    FadeInTransition,
    ErrorPopup,
    InputText,
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    inputStyle: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasError() {
      return this.error !== '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.input {
  position: relative;

  &__popup {
    position: absolute;
    bottom: calc(100% + 8px);
  }

  &__text {
    width: 100%;
  }
}
</style>
